import React from 'react';
import PropTypes from "prop-types";
import {LoadingOverlay} from "../LoadingOverlay";

import {useMediaQuery, useTheme} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DEFAULT_MAX_WITDH = "sm";


const BaseResponsiveDialog = props => {
    const {
        headerEl,
        actionsEl,
        isOpen,
        maxWidth,
        scroll,
        isLoading,
        onClose,
        children,
        disableBackdropClose
    } = props;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const computedMaxWidth = maxWidth || DEFAULT_MAX_WITDH;
    const computedScroll = scroll || 'paper';

    const handleClose = (object, reason) => {
        if (disableBackdropClose && reason === "backdropClick") {
            return;
        }

        onClose();
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth={true}
            maxWidth={computedMaxWidth}
            scroll={computedScroll}
            TransitionComponent={Transition}
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="dialog-title">

            {fullScreen ? (
                <AppBar position="relative" sx={{mb: 3}}>
                    <Toolbar>
                        {headerEl}
                    </Toolbar>
                </AppBar>
            ) : (
                <DialogTitle sx={{display: "flex", flexDirection: "row"}}>{headerEl}</DialogTitle>
            )
            }

            <DialogContent>
                {children}
            </DialogContent>

            {!!actionsEl &&
                <DialogActions sx={{py: 2, px: 3}}>
                    {actionsEl}
                </DialogActions>
            }
            <LoadingOverlay isLoading={!!isLoading}/>
        </Dialog>
    );
};

BaseResponsiveDialog.propTypes = {
    headerEl: PropTypes.node.isRequired,
    actionsEl: PropTypes.node,
    isOpen: PropTypes.bool.isRequired,
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    scroll: PropTypes.oneOf(['body', 'paper']),
    isLoading: PropTypes.bool,
    closeLabel: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    disableBackdropClose: PropTypes.bool,
};

export {BaseResponsiveDialog}
